import { createFileRoute } from '@tanstack/react-router'
import RoyaltyPriceRules from 'Administration/components/royalty/royaltyPriceRules/RoyaltyPriceRules'

import AdministrationPage from '../-administrationPage'
import { Guard } from '../-guard'

export const Route = createFileRoute('/administration/royaltyPriceRules')({
    component: () => (
        <Guard claims={['opus_royalty']}>
            <AdministrationPage>
                <RoyaltyPriceRules />
            </AdministrationPage>
        </Guard>
    ),
})
